import { formatEthAddress, getPrimaryExplorerUrlForAddress } from "@/app/utils/GeneralUtilities";

interface AddressDisplayProps {
  address: string;
  ensName?: string;
}

export default function AddressDisplay({ address, ensName }: AddressDisplayProps) {
  return (
    <span>
      {ensName || formatEthAddress(address)}
    </span>
  );
}
